import {
  CrownOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { AllCommunityModule, ColDef, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { Breadcrumb, ConfigProvider, Pagination, Switch, Tooltip } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Layout from '../../../Layout';
// import TextArea from 'antd/es/input/TextArea';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as BenefitApi from '../../../api/rank/benefitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { NodataTable } from '../../../components/NoDataTable';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { formatNumber } from '../../../services/mixin';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { checkDisabledPermission, CustomLoadingOverlayTable, dataPagination, getUserPermissions } from '../../../until';

import DrawerAddBenefitPolicies from './Component/DrawerAddBenefitPolicies';
import DrawerEditBenefitPolicies from './Component/DrawerEditBenefitPolicies';
import './styles.scss';

ModuleRegistry.registerModules([AllCommunityModule]);




const PolicyBenefits: React.FC = () => {
  const gridRef = useRef<AgGridReact>(null);

  useEffect(() => {
    getListBenefitPolicies()

  }, []);

  const pushToast = useToast();
  const navigator = useNavigate()
  const pushLoading = useLoading()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isDelete, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

  const [isAddCardUser, setAddCardUser] = useState(false)
  const [isOpenDeleteBenefit, setIsOpenDeleteBenefit] = useState(false)

  const [dataBenefit, setDataBenefit] = useState<BenefitApi.DataTypeBenefit[]>([])

  const [id, setId] = useState<number>()
  const [search, setSearch] = useState<string>()
  const [editBenefit, setEditBenefit] = useState(false)


  const [dataInfoBenefit, setDataInfoBenefit] = useState<BenefitApi.IInfoBenefit>()

  if (dataBenefit) {
    dataBenefit.sort((a, b) => a.stt - b.stt)
  }

  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [sort, setSort] = useState<boolean>(false)

  const columnDefs = useMemo<ColDef<BenefitApi.DataTypeBenefit>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'key',
      width: 160,
      sortable: false,
      resizable: false,

      lockPinned: true,
      lockPosition: 'left',
      suppressMovable: true,
      suppressSizeToFit: true,
      cellRenderer: (p: any) => {
        const record: BenefitApi.DataTypeBenefit = p.data;
        return (
          <div className="t-hd-table h-full">
            <div
              onClick={() => { setEditBenefit(true); setId(record.key); }}
              className={`item-hd-table cursor-pointer ${checkDisabledPermission(edit)}`}
            >
              <EditOutlined />
            </div>
            <div
              className={`item-hd-table t-cl-F5222D cursor-pointer ${checkDisabledPermission(isDelete)}`}
              onClick={() => { setIsOpenDeleteBenefit(true); setId(Number(record.key)); }}
            >
              <DeleteOutlined />
            </div>
            <div className={`t-switch-block t-switch-block-sm ${checkDisabledPermission(edit)}`}>
              <Switch
                defaultChecked={!!record.status}
                onChange={() => updateActiveBenefitPolicies(Number(record.key))}
              />
            </div>
          </div>
        );
      },
    },
    {
      headerName: 'Mã quyền lợi',
      field: 'code',
      minWidth: 150,
      resizable: true,
      flex: 1,
      cellRenderer: (p: any) => (
        <div className="t-name-ql">
          <span className="neutral-gray-500 text-2-row">{p.value}</span>
        </div>
      ),
    },
    {
      headerName: 'Tên quyền lợi',
      field: 'title',
      minWidth: 180,
      resizable: true,
      flex: 1,
      cellRenderer: (p: any) => (
        <div className="t-name-ql custom-page-css flex gap-1">
          <div className="icon-svg custom-page-css flex shrink-0"><CrownOutlined /></div>
          <Tooltip title={p.value} placement="topLeft">
            <span className="neutral-gray-500 text-2-row text-truncate">{p.value}</span>
          </Tooltip>
          {/* <span className="neutral-gray-500 text-2-row text-truncate">{p.value}</span> */}
        </div>
      ),
    },
    {
      headerName: 'Thương hiệu xe sở hữu',
      field: 'categoryCar',
      minWidth: 180,
      resizable: true,
      flex: 1,
      cellRenderer: (p: any) => (
        <Tooltip title={p.value} placement="topLeft">
          <div className="t-name-ql">
            <span className="neutral-gray-500 text-2-row">{p.value}</span>
          </div>
        </Tooltip>
      ),
    },
    {
      headerName: 'Mô tả quyền lợi dễ hiểu',
      field: 'description',
      minWidth: 200,
      resizable: true,
      flex: 2,
      cellRenderer: (p: any) => (
        // <div className="text-2-row">{p.value}</div>
        <Tooltip title={p.value} placement="topLeft">
          <span className="neutral-gray-500 text-2-row text-truncate">{p.value}</span>
        </Tooltip>
      ),
    },
  ], [edit, isDelete]);

  const getListBenefitPolicies = async (pageCurent: number = 1, pageSize: number = 10, search: string = '', sort: number = 0) => {
    pushLoading(true)
    const result = await BenefitApi.getListBenefitPolicies(pageSize, pageCurent, search, sort);
    if (result?.status) {
      setDataBenefit(convertData(result.data, pageCurent, pageSize))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, 'error', 2000)
    }
    pushLoading(false)
  }

  const convertData = (data: BenefitApi.IBenefit[], pageCurent: number, pageSize: number) => {
    var stt = (pageCurent - 1) * pageSize + 1;
    // console.log(pageCurent, pageSize);
    const convertData = data.map((item) => ({
      key: item.id,
      stt: stt++,
      code: item.code,
      title: item.title,
      description: item.description,
      categoryCar: item.categoryCar,
      status: item.status
    }))
    return convertData
  }


  const infoBenefitPolicies = async (id: number) => {
    const result = await BenefitApi.infoBenefitPolicies(id);
    if (result?.status) {
      setDataInfoBenefit(result.data)
      console.log(result.data);
    } else {
      pushToast(result.message, 'error')
    }
  }

  // thay đổi trang thái
  const updateActiveBenefitPolicies = async (id: number) => {

    const result = await BenefitApi.updateActiveBenefitPolicies(id);
    if (result?.status) {
      getListBenefitPolicies(pagination.current, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)
    }
    pushLoading(false)
  }

  const handleDelete = async () => {
    if (!id) return
    pushLoading(true)
    const result = await BenefitApi.deleteBenefitPolicies(id);
    if (result?.status) {
      getListBenefitPolicies(pagination.current, pagination.pageSize)
      setIsOpenDeleteBenefit(false)
      pushToast(result.message, "success", 2000)

    } else {
      pushToast(result.message, "error", 2000)
    }
    pushLoading(false)
  }

  const handleChangePagination = (current: number, pageSize: number) => {
    setPaginationTmp(current);
    setPagination((prev) => ({ ...prev, current: current, pageSize }))
    getListBenefitPolicies(current, pageSize)
  }

  useEffect(() => {
    if (id) {
      infoBenefitPolicies(id)
    } else {
      // navigator(-1)
    }
  }, [id]);

  return (
    <div className='card-issuance-list'>
      <Layout>
        {/* {
          isAddCardUser
            ? <ShowAddBenefitPolicies
              className="show"
              closeModal={() => setAddCardUser(!isAddCardUser)}
              getListBenefit={getListBenefitPolicies}
            />
            : null
        } */}

        <DrawerAddBenefitPolicies
          isOpen={isAddCardUser}
          closeDrawer={() => setAddCardUser(false)}
          getListBenefit={getListBenefitPolicies}
        />

        <DrawerEditBenefitPolicies
          isOpen={editBenefit}
          closeDrawer={() => setEditBenefit(false)}
          dataInfoBenefit={dataInfoBenefit}
          getListBenefit={getListBenefitPolicies}
        />

        <ModalDeleteManager
          isOpen={isOpenDeleteBenefit}
          title="Bạn có chắc chắn xóa quyền lợi này?"
          titleDelete="Xoá quyền lợi này"
          content="Quyền lợi này sẽ bị xóa và vĩnh viễn không thể khôi phục"
          onConfirm={handleDelete}
          closeModal={() => setIsOpenDeleteBenefit(false)}
        />

        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Chương trình KH thành viên</a>,
            },
            {
              title: 'Quyền lợi chính sách CSKH',
            },
          ]}
        />

        <div className='title-page'>
          Quản lý quyền lợi chính sách CSKH
        </div>

        {/* Fillter block */}
        <div className='filter-block ctrl-filter-benefits'>
          <div className="title-block">Danh sách quyền lợi</div>

          <div className={`btn-input btn-primary ${checkDisabledPermission(add)}`}>
            <div
              className="t-btn-link-icon"
              onClick={() => setAddCardUser(true)}
            >
              <div className="icon-svg"><PlusCircleOutlined /></div>
              <div className="text">Thêm mới</div>
            </div>
          </div>
        </div>

        <div className="t-table-block t-table-benefits custom-page-css flex flex-col flex-1 justify-between">
          <div className="ag-theme-alpine empty-test-td custom-table-ag-v2" style={{ width: '100%' }}>
            <AgGridReact
              ref={gridRef}
              domLayout="autoHeight"
              rowData={dataBenefit}
              columnDefs={columnDefs}
              defaultColDef={{ resizable: true, sortable: false }}
              getRowId={(params) => params.data.key.toString()}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              overlayNoRowsTemplate={NodataTable}
              rowHeight={55}
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
            />
          </div>

          <ConfigProvider locale={viVN}>
            <div className="pagination-block d-flex justify-center">
              <Pagination
                total={pagination.total}
                current={paginationTmp}
                pageSize={pagination.pageSize}
                showSizeChanger
                // showQuickJumper
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
                locale={{ items_per_page: 'trang' }}
                onChange={handleChangePagination}
              />
            </div>
          </ConfigProvider>
        </div>
      </Layout>
    </div>
  );
}

export default PolicyBenefits;
